/*
 * AssignAndVideo Messages
 *
 * This contains all the text for the AssignAndVideo component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  assignHelp: {
    id: 'app.components.AssignAndVideo.assignHelp',
    defaultMessage: 'Assign parents/guardians to time slots.',
  },
  assignVideoHelp: {
    id: 'app.components.AssignAndVideo.assignVideoHelp',
    defaultMessage: 'Assign parents/guardians to time slots and add videoconferences to meetings.',
  },
  overview: {
    id: 'app.components.AssignAndVideo.overview',
    defaultMessage: 'Overview',
  },
  provider: {
    id: 'app.components.AssignAndVideo.provider',
    defaultMessage: 'Provider',
  },
  meetingsAssigned: {
    id: 'app.components.Period.meetingsAssigned',
    defaultMessage: 'meetings assigned',
  },
  slotsAvailable: {
    id: 'app.components.Period.slotsAvailable',
    defaultMessage: 'time slots available',
  },
  viewUnplanned: {
    id: 'app.components.Period.viewUnplanned',
    defaultMessage: 'View unplanned meetings',
  },
  videoConferences: {
    id: 'app.components.AssignAndVideo.videoConferences',
    defaultMessage: 'Video Conferences',
  },
  expandAll: {
    id: 'app.components.Goals.expandAll',
    defaultMessage: 'Expand All',
  },
  collapseAll: {
    id: 'app.components.Goals.collapseAll',
    defaultMessage: 'Collapse All',
  },
  blockHeader: {
    id: 'app.components.Planner.BlockModal.header',
    defaultMessage: 'Block {id}: {time}',
  },
  noVideoMeetingsAssigned: {
    id: 'app.components.AssignAndVideo.noVideoMeetingsAssigned',
    defaultMessage: "No meetings with location 'Video Conference' have been assigned yet",
  },
  videoMeetingsLinked: {
    id: 'app.components.AssignAndVideo.videoMeetingsLinked',
    defaultMessage: 'meetings have a video conference link',
  },
  addVideoLink: {
    id: 'app.components.AssignAndVideo.addVideoLink',
    defaultMessage: 'Add Video Conference Link',
  },
  addVideoLinks: {
    id: 'app.components.AssignAndVideo.addVideoLinks',
    defaultMessage: 'Add Video Conference Links',
  },
  addLinks: {
    id: 'app.components.AssignAndVideo.addLinks',
    defaultMessage: 'Add Links',
  },
  videoModal: {
    id: 'app.components.AssignAndVideo.videoModal',
    defaultMessage: "<ul><li>A video conference link will be added to all meetings that don't have a link yet and have the location set to 'Video Conference'.</li><li>Video conferences will be created in the {type} calendar of {email}. The link will be added to the meeting.</li><li>Colleagues with the organisation can also start the video conferences en admit parents and guardians.</li></ul><p><b>Note:</b>  After you add the video conference link, parents/guardians cannot change the meeting time anymore. Add the links only at the end of the registration period.</p>",
  },
  break: {
    id: 'app.components.Planner.BlockModal.break',
    defaultMessage: 'Break',
  },
  assign: {
    id: 'app.components.Planner.BlockModal.assign',
    defaultMessage: 'Assign',
  },
  unassign: {
    id: 'app.components.Planner.BlockModal.unassign',
    defaultMessage: 'Unassign',
  },
  block: {
    id: 'app.components.Planner.BlockModal.block',
    defaultMessage: 'Block',
  },
  unblock: {
    id: 'app.components.Planner.BlockModal.unblock',
    defaultMessage: 'Unblock',
  },
  blocked: {
    id: 'app.components.Planner.BlockModal.blocked',
    defaultMessage: 'Blocked',
  },
  timeslotGone: {
    id: 'app.components.MeetingsBlock.timeslotGone',
    defaultMessage: 'The time slot is not available anymore, select another slot',
  },
  meetingGone: {
    id: 'app.components.Planner.BlockModal.meetingGone',
    defaultMessage: 'The meeting has been removed',
  },
  confirmCancelMeeting: {
    id: 'app.common.confirmCancelMeeting',
    defaultMessage: 'Remove meeting with parents/guardians of {displayName}?',
  },
  privacyStatement: {
    id: 'app.components.AssignAndVideo.privacyStatement',
    defaultMessage: 'Privacy Statement',
  },
  privacyVideo: {
    id: 'app.components.AssignAndVideo.privacyVideo',
    defaultMessage: 'Read the <aen>Privacy Statement</aen> for information on how we handle access to your Microsoft or Google account.',
  },
  privacyStatementLink: {
    id: 'app.components.AssignAndVideo.privacyStatementLink',
    defaultMessage: '<aen>Privacy Statement</aen>',
  },
});
